export const getImgUrl = name => {
  // const imageAssetsUrl = 'https://localhost:9090/';
  const imageAssetsUrl = '';
  return `${ imageAssetsUrl }${ name }`;
}
